// @flow
import fetch from '../fetch';
import { apiEndpoint, getApiUrl } from './index';

export const getEans = (): Promise =>
  fetch(apiEndpoint('v1/eans'), {
    baseURL: getApiUrl(),
  });
